export const focusOnAnyBttnElement = (elementUniqueId:string) => {
  const elementId = `${elementUniqueId}-button`;
  focusOnElement(elementId);
};

export const focusOnElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  element?.focus();
};
